import { Button, DataHeader, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutWebUser extends Layout {
    buttonOpenClassic: Button;
    buttonReset: Button;
    dataheaderWebUsers: DataHeader;
    horizontalspacer1: HorizontalSpacer;
    labelActive: Label;
    labelAssociatedLocations: Label;
    labelLabelCarriers: Label;
    labelLabelGeneral: Label;
    labelLabelOptions: Label;
    panelAssociatedLocations: Panel;
    panelColumn1: Panel;
    panelColumn2: Panel;
    panelColumn3: Panel;
    panelEditingHeader: Panel;
    panelFactoringCompanyFields: Panel;
    panelUserHeader: Panel;
    sourceWebLocation: DataSource;
    sourceWebUsers: DataSource;
    switchActive: Switch;
    switchBridgeCustomer: Switch;
    tableAssociatedLocations: Table;
    textboxAcctLockDate: Textbox;
    textboxAllowWebTendering: Textbox;
    textboxAvailTractPath: Textbox;
    textboxContactName: Textbox;
    textboxDeliveredLoadDay: Textbox;
    textboxEmailAddress: Textbox;
    textboxFileimportProfile: Textbox;
    textboxHdrEmailAddress: Textbox;
    textboxHdrId: Textbox;
    textboxHdrPhone: Textbox;
    textboxHdrSourceId: Textbox;
    textboxHdrSourceName: Textbox;
    textboxId: Textbox;
    textboxImgCategory: Textbox;
    textboxLoginId: Textbox;
    textboxName: Textbox;
    textboxPayeeId: Textbox;
    textboxPhone: Textbox;
    textboxPortalAdminId: Textbox;
    textboxRevenueCodeId: Textbox;
    textboxTypeNumber: Textbox;
    textboxUserGroup: Textbox;
    textboxWebAcctStatus: Textbox;
    textboxWebCreatedOn: Textbox;
    textboxWebEnabledOn: Textbox;
    textboxWebLastLogin: Textbox;
    textboxWebLockedOn: Textbox;
    textboxWebUserType: Textbox;
}
